export const News = () => {
  return (
    <div>
      <p>
        esta es la sección donde aparecerán las noticias relacionadas a las
        películas, el trabajo importante aquí es hacer los componentes y simular
        que recuperan información de no sé, una BD, pero lo harémos desde algo
        local, como aray de objetos
      </p>
    </div>
  );
};

export default News;
